// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c402aec1","455":"46ac4464","977":"074b7863"}[chunkId] + ".chunk.js";
};